<script setup lang="ts">
import { generateSlug } from 'random-word-slugs'

const { createChild } = useApi()

const dialog = defineModel<boolean>()
const emit = defineEmits(['stateChanged'])
const loading = ref<boolean>(false)

const generateName = () => {
  return generateSlug(2, {
    format: 'title',
    partsOfSpeech: ['adjective', 'noun'],
    categories: {
      adjective: [
        'color',
        'appearance',
        'condition',
        'personality',
        'shapes',
        'size',
        'touch',
      ],
      noun: ['animals', 'food', 'transportation'],
    },
  })
    .split(' ')
    .concat([`${Math.floor(Math.random() * 90000) + 10000}`])
    .join('')
}

const newNameCandidate = ref<string>('')

watch(dialog, () => {
  if (dialog.value) {
    newNameCandidate.value = generateName()
  }
})

const onSubmit = async () => {
  try {
    loading.value = true
    await createChild(newNameCandidate.value)
    emit('stateChanged')
  }
  catch (error) {
    alert(error)
  }
  finally {
    dialog.value = false
    loading.value = false
  }
}

const onMakeChild = () => {
  newNameCandidate.value = generateName()
}
</script>

<template>
  <Dialog
    v-model="dialog"
    title="子アカウントの作成"
    :cancel-button="{ title: 'とじる' }"
  >
    <template #default>
      <v-container class="align-center w-75">
        <v-text-field
          v-model="newNameCandidate"
          readonly
          label=""
          class="name-edit text-center"
        />
        <v-row class="my-4 text-center">
          <v-col> この名前で作成しますか？ </v-col>
        </v-row>
        <v-row>
          <v-col
            col="6"
            class="text-center"
          >
            <v-btn
              variant="elevated"
              size="xlarge"
              color="primary"
              class="pa-3"
              :loading="loading"
              @click="onSubmit"
            >
              この名前で作成する
            </v-btn>
          </v-col>
          <v-col
            col="6"
            class="text-center"
          >
            <v-btn
              variant="elevated"
              size="xlarge"
              color="secondary"
              class="pa-3"
              :disabled="loading"
              @click="onMakeChild"
            >
              別の名前にする
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </template>
  </Dialog>
</template>

<style scoped>
.name-edit * {
  font-size: 120%;
}

.name-edit :deep(input) {
  font-family: "Google Sans Code", sans-serif;
  font-weight: 700;
  text-align: center;
}
</style>
